import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dca-calculator',
  component: () => import('../../routes/DcaCalculator.svelte'),
  card: {
    id: 'dca-calculator',
    title: 'Dollar-Cost Averaging',
    description: 'Compare lump sum vs periodic investing to see which strategy grows your money faster.',
    icon: 'candlestick_chart',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/dca-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Dollar-Cost Averaging Calculator – DCA vs Lump Sum Investing',
    description: 'Free dollar-cost averaging calculator. Compare DCA vs lump sum investing strategies with year-by-year growth projections. See which approach grows your money faster with monthly, biweekly, or weekly contributions.',
  },
};

export default meta;
